<template lang="pug">
  v-container.px-10(fluid)
    v-row
      v-col
        .section__title {{ $t("Party.generalInformation") }}
    v-row
      v-col(cols="3")
        app-entity-autocomplete(
          :entity="$findEntity('BusinessScope')",
          v-model="instance.businessScope",
          :init="instance.businessScope",
          :label="$t('Party.businessScope')"
        )
      v-col(cols="3")
        v-text-field(
          v-model="instance.externalId",
          :label="$t('Party.externalId')",
          disabled
        )
      v-col(cols="6")
        v-text-field(
          v-model="instance.name",
          :label="$t('Party.name')",
          :error-messages="errors['party.name']",
        )
      v-col(cols="5")
        v-text-field(
          v-model="instance.streetName",
          :label="$t('Party.streetName')",
          :error-messages="errors['party.streetName']",
        )
      v-col(cols="5")
        v-text-field(
          v-model="instance.interiorNumber",
          :label="$t('Party.interiorNumber')",
          :error-messages="errors['party.streetName']",
        )
      v-col(cols="2")
        v-text-field(
          v-model="instance.postalCode",
          :label="$t('Party.postalCode')",
          :error-messages="errors['party.postalCode']",
        )
      v-col(cols="3")
        v-autocomplete(
          v-model="countrySelected",
          :label="$t('Party.countryName')",
          :items="countries",
          item-text='name'
          return-object
          @change="setCountry"
        )
      v-col(cols="1")
        v-text-field(
          v-model="instance.countryCode",
          :label="$t('Party.countryCode')",
          disabled
        )
      v-col(cols="2")
        v-text-field(
          v-model="instance.stateName",
          :label="$t('Party.stateName')",
        )
      v-col(cols="2")
        v-text-field(
          v-model="instance.cityName",
          :label="$t('Party.cityName')",
        )
      v-col(cols="4")
        v-text-field(
            v-model="instance.openingHours",
            :label="$t('Party.openingHours')",
            :error-messages="errors['Party.openingHours']",
          )
      v-col(cols="4")
        v-text-field(
          v-model="instance.remarks1",
          :label="$t('Party.remarks')",
          :error-messages="errors['Party.remarks1']",
        )

    v-row
      v-col(cols="12")
        v-container.px-0(fluid)
          div(style='width: 100%; height: 400px; position: relative; z-index:1')
            #map
          v-row
            v-col(col="1")
               v-text-field(
                v-model="instance.latitude",
                :label="$t('Party.latitude')",
                disabled,
                :error-messages="errors['Party.latitude']"
              )
            v-col(col="2")
              v-text-field(
                v-model="instance.longitude",
                :label="$t('Party.longitude')",
                disabled,
                :error-messages="errors['Party.longitude']"
              )
            v-col(col="8")
              v-container(fluid)
                v-dialog(v-if="ShowButton('Party', 'validateAddress')" v-model="dialog", max-width="600")
                  template(v-slot:activator="{ on }")
                    v-btn.mr-5(v-on="on",
                      color="primary",
                      outlined,
                      @click="SearchData"
                    ) {{ $t("Common.validate") }}
                  v-card
                    v-progress-linear(:active="loading", indeterminate, color="primary", absolute, top)
                    v-btn(@click="dialog = false", fab, dark, small, style="position: absolute; right: 5px; top: 5px; z-index: 401;")
                        v-icon mdi-close
                    v-container.py-0(fluid)
                      v-row(v-if="!NoResults")
                        #dialogMap(ref="map", style='width: 100%;')
                      v-row.px-3
                        v-alert.p-5(v-if="NoResults", border="bottom", colored-border, type="warning", elevation="2", style='width: 100%;')
                          p {{ $t("Party.noResults") }}
                          p {{ $t("Party.tryAgainAddress") }}

                        v-hover(v-for="site in searchResults", v-slot:default="{ hover }", open-delay="200")
                          v-card.mb-2(:elevation="hover ? 16 : 2" class="mx-auto", @click="setMarkerResult(site)")
                            v-row.px-4
                              v-col(cols="9", style="cursor: pointer")
                                span {{ $t("Party.details") }}:
                                h4() {{site.display_name}}
                              v-col(cols="3")
                                v-btn(color="primary", outlined @click="select(site)") {{ $t("Common.select") }}
                v-btn(
                  v-if="ShowButton('Party', 'resetAddress')"
                  @click="reset()",
                  color="primary",
                ) {{ $t("Common.reset") }}
    v-row
      v-col(cols="12")
        .section__title {{ $t("Party.addContacts") }}
        .section__subtitle {{ $t("Party.availableContactMessage") }}
    v-container
      v-row
        v-col(cols="6")
          h2.primary--text {{ $t("Party.searchForContacts") }}
          app-entity-autocomplete(
            :entity="$findEntity('Contact')",
            :emit="true",
            v-model="where",
            @input="getContactList",
          )
          v-card(v-if="hasAvailableContacts")
            v-list
              v-list-item(
                v-for="contact in contactList"
                :key="contact.uid"
              )
                v-list-item-content
                  v-list-item-title {{contact.fullNameEmail}}
                v-list-item-icon
                  v-icon(@click="addContact(contact)") mdi-plus
        v-col(cols="6")
          h2.primary--text {{ $t("Party.linkedContacts") }}
          v-card(v-if="filteredContactList.length")
            v-list
              v-list-item(
                v-for="contact in filteredContactList"
                :key="contact.uid"
              )
                v-list-item-content
                  v-list-item-title {{contact.contact.fullNameEmail}}
                v-list-item-icon
                  v-icon(@click="removeContact(contact)") mdi-close
</template>
<style >
#map {
  height: 400px;
}
#dialogMap {
  height: 200px;
  position: relative !important;
}
.leaflet-default-icon-path {
    background-image: url(/images/marker-icon.png);
}
.leaflet-default-shadow-path {
    background-image: url(/images/marker-shadow.png);
}
.v-text-field--filled input {
  margin-top: 16px !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: inherit !important;
}
</style>
<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
    name: 'entity-add',
    mixins: [EntityMixin],
    data: () => ({
        dialog: false,
        loading: false,
        searchResults: null,
        NoResults: true,
        marker: null,
        map: null,
        businessScopes: [],
        where: null,
        contactList: [],
        whereList: null,
        timer: null,
        wait: 500,
        countries: [],
        countrySelected: {}
    }),
    computed: {
        uid() {
            return this.$route.params.item
        },
        hasAvailableContacts() {
            return !_.isEmpty(this.contactList);
        },
        filteredContactList() {
            return (this.instance.contactParties || []).filter(x => x.entityState !== ENV.ENTITY.STATE.DELETED);
        },
        errors() {
            return this.$store.state.errors;
        }
    },
    methods: {
        setCountry(country) {
          console.log(this.$cleanString(country));
          this.countrySelected = country
          this.instance.countryName = this.countrySelected.name
          this.instance.countryCode = this.countrySelected.twoLetterCode;
        },
        async loadCountries() {
          try {
            const endpoint = this.$fetchLoad(`Countries`, true)
            this.countries = (await axios.get(endpoint, { params: { pageSize: -1, withoutGlobalBusinessScope: true, withoutLoadBusinessScope: true }})).data.data;
          } catch (error) {
            console.error(error);
          }
        },
        /**
         * Clean all the values in the input text
         */
        reset() {
            this.instance.referenceId =
                this.instance.name =
                this.instance.streetName =
                this.instance.postalCode =
                this.instance.countryName =
                this.instance.stateName =
                this.instance.cityName =
                this.instance.remarks1 =
                this.instance.latitude =
                this.instance.longitude = '';
            this.initializingMap();
        },
        /**
         * Set the a marker in the dialogMap from the list
         */
         async setMarkerResult(site) {
            var coords = {
                lat: site.lat,
                lng: site.lon
            };
             if(this.dialogMap)
             this.dialogMap.remove();
            const markerx = {
                visible: true,
                draggable: false,
                icon: L.divIcon({
                    html: '<i class="mdi mdi-crosshairs-gps map__icon primary--text" style="font-size: 40px;"></i>',
                    iconSize: [30, 30],
                    className: 'map__icon-wrapper'
                })
            };
            this.dialogMap = L.map('dialogMap').setView(coords, 17);
            let res = await axios.get('https://nominatim.openstreetmap.org/details?osmtype=W&osmid='+site.osm_id+'&format=json&polygon_geojson=1');
            if(res.data.geometry)
            {
              const myStyle = {
                  "color": "#3200E6",
                  "weight": 5,
              };
              L.geoJSON(res.data.geometry, {
                style: myStyle
              }).addTo(this.dialogMap);
            }
            var marker = L.marker(coords, markerx)
                .addTo(this.dialogMap);
            this.tileLayer = window.L.tileLayer(
                'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 18
                }
            ).addTo(this.dialogMap);
        },
        /**
         * Check if the values from the instance are empty, if not make the search
         */
        SearchData() {
            if (_.chain(this.instance).pick(
                    ['streetName', 'postalCode', 'countryName', 'stateName', 'cityName']
                ).every(Boolean).value()) {
                    this.geocoding();
            }
            else {
                this.dialog=false;
                this.searchResults=null;
                return
            }
        },
        /**
         * Set the values from the result in the dialog box, and put the marker
         */
         async select(site) {
            this.instance.latitude = site.lat;
            this.instance.longitude = site.lon;
            this.instance.countryName = site.address.country
            this.instance.stateName = site.address.state;
            this.instance.cityName = site.address.city;
            var coords = {
                lat: site.lat,
                lng: site.lon
            };
            if(this.map)
            this.map.remove();
            const markerx = {
                visible: true,
                draggable: true,
                icon: L.divIcon({
                    html: '<i class="mdi mdi-crosshairs-gps map__icon primary--text" style="font-size: 40px;"></i>',
                    iconSize: [30, 30],
                    className: 'map__icon-wrapper'
                })
            };
            this.map = L.map('map').setView(coords, 17);
            var marker = L.marker(coords, markerx)
                .addTo(this.map);
            marker.addEventListener("dragend", this.getGPS);
            this.tileLayer = window.L.tileLayer(
                'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 18
                }
            ).addTo(this.map);
            let res = await axios.get('https://nominatim.openstreetmap.org/details?osmtype=W&osmid='+site.osm_id+'&format=json&polygon_geojson=1');
            if(res.data.geometry)
            {
              const myStyle = {
                  "color": "#3200E6",
                  "weight": 5,
              };
              L.geoJSON(res.data.geometry, {
                style: myStyle
              }).addTo(this.map)
              // .bindPopup('Use the marker near the location, use the line as a reference guide')
              // .openPopup();
            }
            this.dialog = false;
        },
        /**
         * Get the contact list for the autocomplete component
         */
        async getContactList() {
            clearTimeout(this.timer)
            this.timer = setTimeout(async () => {
                this.loading = true
                try {
                    this.contactList = (await axios.get('Contact', {
                        params: {
                            where: this.where,
                            pageSize: 20,
                        }
                    })).data.data;
                } catch (err) {}
                this.loading = false
            }, this.wait)
        },
        /**
         * Add Contact
         */
        addContact(contact) {
            // If not found, then add ContactParty. Else, if it is deleted (cannot see it) change to added.
            const f = this.instance.contactParties.find(x => x.contact.uid === contact.uid);
            if (!f) {
                this.instance.contactParties.push({
                    contact: contact,
                    entityState: ENV.ENTITY.STATE.ADDED,
                    _Entity: "ContactParty"
                });
            } else {
                if (f.entityState === ENV.ENTITY.STATE.DELETED) f.entityState = ENV.ENTITY.STATE.ADDED;
            }

            if (this.instance.entityState === 0 || this.instance.entityState === 1) this.instance.entityState = 3;
        },
         /**
         * Remove a Contact
         */
        removeContact(contact) {
            // If added remove from list, else just convert to delete
            if (contact.entityState === ENV.ENTITY.STATE.ADDED) {
                this.instance.contactParties = this.instance.contactParties.filter(x => x.contact.uid !== contact.contact.uid);
            } else {
                const i = _.findIndex(this.instance.contactParties, x => x.contact.uid === contact.contact.uid);
                if (i !== -1) this.instance.contactParties.splice(i, 1, {
                    ...contact,
                    entityState: ENV.ENTITY.STATE.DELETED,
                    _Entity: "ContactParty"
                });
            }
            if (this.instance.entityState === 0 || this.instance.entityState === 1) this.instance.entityState = 3;
        },
        /**
         * Make the call to the nominatim service
         * TODO: the url of nominatim need to be storage as variable in the .env
         */
        async geocoding() {
            let params
            let res
            this.searchResults = null;
            const Nominatim = axios.create({
                headers: {
                    'X-Custom-Header': 'foobar',
                    'Authorization': '',
                    "Content-Type": "application/json",
                    'crossDomain': true
                }
            });
            // [Nominatim] Task 5356: The search has been defined as structured
            // the search params  need to be filled
            params = [
                    'street=' + this.instance.streetName,
                    'postalcode=' + this.instance.postalCode,
                    'city=' + this.instance.cityName,
                    'state=' + this.instance.stateName,
                    'country=' + this.instance.countryName
                ]
                .filter(Boolean)
                .join('&')
            try {
                this.loading=true;
                res = await Nominatim.get([
                    `https://nominatim.openstreetmap.org/search?${params}`,
                    `&format=json`,
                    `&addressdetails=1`,
                    `&limit=3`
                ].join(''))
                if (res.data.length) {
                    this.NoResults=false;
                    this.searchResults = res.data;
                    this.$nextTick(() => {
                    this.dialogMap = window.L.map('dialogMap', {
                        attributionControl: true
                    }).setView(
                        [res.data[0].lat, res.data[0].lon], 10);
                    this.tileLayer2 = window.L.tileLayer(
                        'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            maxZoom: 18
                        }
                    ).addTo(this.dialogMap);
                    });
                    this.loading=false;
                    return
                }
                else
                {
                  console.log("SECOND SEARCH");
                  let q = [ this.instance.streetName,
                    this.instance.postalCode,
                    this.instance.cityName,
                    this.instance.stateName,
                    this.instance.countryName ]
                    .filter(Boolean)
                    .join(',');
                  res = await Nominatim.get([
                      `https://nominatim.openstreetmap.org/search.php?q=${q}`,
                      `&format=json`,
                      `&addressdetails=1`,
                      `&limit=3`
                    ].join(''))
                  if (res.data.length)
                  {
                    this.NoResults=false;
                    this.searchResults = res.data;
                    this.$nextTick(() => {
                    this.dialogMap = window.L.map('dialogMap', {
                        attributionControl: true
                    }).setView(
                        [res.data[0].lat, res.data[0].lon], 10);
                    this.tileLayer2 = window.L.tileLayer(
                        'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            maxZoom: 18
                        }
                    ).addTo(this.dialogMap);
                    });
                    this.loading=false;
                    return
                  }
                  else
                  {
                    this.NoResults=true;
                    this.loading=false;
                  }
                }
            } catch (errors) {
                console.log('ERROR ', this.$cleanString(errors));
                return
            }
        },
        /**
         * On edit mode set the map and marker for existing values.
         */
        async setMap(party){
            let coords = {
                lat: party.latitude,
                lng: party.longitude
            };
          if(party.latitude!=null && party.longitude!= null){
              const markerx = {
                  visible: true,
                  draggable: true,
                  icon: L.divIcon({
                      html: '<i class="mdi mdi-crosshairs-gps map__icon primary--text" style="font-size: 40px;"></i>',
                      iconSize: [30, 30],
                      className: 'map__icon-wrapper'
                  })
              };
              if(this.map)
              this.map.remove();
              this.map = L.map('map').setView(coords, 17);
              var marker = L.marker(coords, markerx)
                  .addTo(this.map);
              marker.addEventListener("dragend", this.getGPS);
              this.tileLayer = window.L.tileLayer(
                  'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                      maxZoom: 18
                  }
              ).addTo(this.map);



          }
        },
        /**
         * Set the new latitude and longitude after the marker it's dragged.
         */
        getGPS(eventx) {
            this.instance.latitude = eventx.target._latlng.lat
            this.instance.longitude = eventx.target._latlng.lng
        },
         /**
         * Create the map component and set a view over america
         */
        initializingMap() {
            this.map = window.L.map('map', {
                attributionControl: false
            }).setView(
                [33.9758773, -103.3537223], 1);
            this.tileLayer = window.L.tileLayer(
                'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 18
                }
            ).addTo(this.map);
        },
         /**
         * Load the party by uid, include the ContactParties & ContactParties.Contact
         */
        async load() {
            if (this.uid) {
                try {
                    this.instance = (await axios.get(`Party/${this.uid}?load[]=ContactParties&load[]=ContactParties.Contact&load[]=ExtraData`, {
                        _Entity: 'Party',
                        uid: this.uid
                    })).data
                    this.instance.entityState = 3;
                    this.setMap(this.instance);
                    this.countrySelected = this.instance.countryName;
                } catch (error) {
                    console.error(error)
                }
            } else {
                this.instance = {
                    contactParties: [],
                    businessScope: this.$store.state.user.user.businessScope,
                }
            }
        },
        /**
         * Check permissions to see if the user is able to see the Validate/Reset buttons
         */
        ShowButton(name, attribute)
        {
          let entity = this.$store.state.schema.all.find(p => name == p.name);
          return entity.actions[attribute];
        }
    },
    /**
    * The component of the map need to be in the mounted()
    */
    async mounted() {
        this.initializingMap();
        this.getContactList();
        this.loadCountries();
    },
    async created() {
        await this.load()
    },
}
</script>

